<template>
   
    <div class="selected-record drop-shadow">
        
        <div class="inner" v-if="stagedCandidateForm.fields.forCandidateId.value != ''">
            <div class="title">
                <h4>Update existing candidate</h4>
                <hr/>
            </div>
            <div class="row">
                <div class="lhs">
                    <div class="data">
                        <div class="label">{{stagedCandidate.brandedPublicId}}</div>
                        <div class="value">{{stagedCandidate.forename.sf}} {{stagedCandidate.surname.sf}}</div>
                    </div>


                </div>
                <div class="rhs">
                    <div class="data">
                        <div class="label">{{countryLabel}}</div>
                        <div class="value">{{stagedCandidate.city.sf}}</div>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="full">
                    <div class="buttons text-right" v-if="!externalId">
                        <a :href="sfLink" target="_blank" class="button hollow">View</a>
                        <a href="" class="button" @click.prevent="$emit('reselect')">Reselect</a>
                    </div>
                    <div class="single-button" v-else>
                        <a :href="sfLink" target="_blank" class="button">View in Salesforce</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner" v-else-if="!stagedCandidateDuplicatesExist">
            <div class="title text-center">
                <h4>New candidate</h4>
                <hr/>
            </div>
            <div class="row">
                <p class="info-text text-center">The candidate’s details have not been matched to any existing record.</p>
            </div>
        </div>
        <div class="inner no-link text-center" v-else>
            <div class="title">
                <h4>Duplicate record</h4>
                <hr/>
            </div>

            <div class="row">
                <p class="info-text text-center">A candidate record already exists for this email address and brand.  You have opted to create a new record.</p>
            </div>
            <div class="row">
                <div class="full">
                    <div class="single-button">
                        <a href="" class="button" @click.prevent="$emit('reselect')">Reselect candidate</a>
                    </div>
                </div>
            </div>
        </div>

    </div>    
                
</template>

<script>
    export default {
        name: 'SelectedRecord',
        computed: {
            stagedCandidate() {
                return this.$store.state.cvUpload.stagedCandidate;
            },
            stagedCandidateForm() {
                return this.$store.state.cvUpload.stagedCandidateForm;
            },
            stagedCandidateDuplicatesExist() {
                return this.$store.state.cvUpload.stagedCandidateDuplicates && Object.keys(this.$store.state.cvUpload.stagedCandidateDuplicates).length > 0;
            },
            externalId() {
                return this.$route.query.externalId != '' ? this.$route.query.externalId : null;
            },
            countries() {
                return this.$store.state.app.lookup['Country'] || [];
            },
            countryLabel() {
                if (this.stagedCandidateForm.fields.forCandidateId.value != '') {
                    for (let i = 0; i < this.countries.length; i++) {
                        if (this.stagedCandidateForm.fields.country.value === this.countries[i].value) {
                            return this.countries[i].label;
                        }
                    }
                    return this.stagedCandidateForm.fields.country.value;
                } else {
                    return null;
                }
            },
            environment() {
                return this.$store.state.app.environment || '';
            },
            theme() {
                return this.$store.state.user.theme || '';
            },
            sfLink() {
                let url = this.environment;
                if (this.theme === 'lightning') {
                   url += '/lightning/r/Contact/' + this.stagedCandidate.externalId + '/view?0.source=alohaHeader';
                }  else {
                   url += '/apex/ContactView?id=' + this.stagedCandidate.externalId;
                }
                return url;
            }
        },
    }
</script>

<style scoped>
    
     .selected-record {margin-bottom: 1.5rem; background-color: #fff; /*background: var(--colour-primary); border: solid .1rem var(--colour-primary-dark); color: #fff; text-shadow: 0.05rem 0.05rem 0.1rem #000000;*/}
        .selected-record .inner {width: 100%;}
        .selected-record .title {padding: 1rem 1rem 0rem 1rem;}
            .selected-record .title hr {margin: 1rem 0;}
        .selected-record .row {padding: 0rem 1rem 1rem 1rem; display: flex; flex-wrap: wrap;}
            .selected-record .row .lhs {flex-grow: 1; margin-top: auto;}
            .selected-record .row .rhs {flex-grow: 1; text-align: right; margin-top: auto;}
            .selected-record .row .full {flex-grow: 1; margin-top: auto;}
        .selected-record .info-text {width: 100%;}
        .selected-record .data-small {font-size: .8rem;}
        .selected-record .data-small + .data-small {margin-top: .25rem;}
    
        .selected-record .data + .data {margin-top: 1rem;}
            .selected-record .data .label {font-size: .7rem; font-weight: bold; text-transform: uppercase; display: table; word-break: break-word; width: 100%;}
            .selected-record .data .value {font-family: 'Roboto Condensed', sans-serif; font-size: 1.25rem; font-weight: bold; display: table; word-break: break-word; width: 100%;}
    
        .selected-record .buttons {display: flex; justify-content: space-between;}
            .selected-record .buttons .button {width: 50%;}
            .selected-record .buttons .button + .button {margin-left: .5rem;}
            .selected-record .single-button .button {width: 100%; box-sizing: border-box;}
    

        /*.selected-record .no-link .buttons {justify-content: flex-end;}
            .selected-record .no-link .buttons.view-button-only .button {width: 100%;}*/
            

        @media screen and (max-width: 550px) {
            .selected-record > .row .lhs, .duplicate > .row .rhs {width: 100%; text-align: left;}
            .selected-record > .row .lhs {padding-bottom: 1rem;}
            .selected-record .buttons {text-align: right;}
        }

    
</style>